import React from "react";
import { connect } from "react-redux";
import HabitDetail from "../../../../Profile/Home/ProfileInformation/Habit/HabitDetail";
import getMemberHabitProfile from "../../../../../_selectors/profileSelectors/getMemberHabitProfile";

const Habit = ({ userProfile, showToast }) => {
  return <HabitDetail userProfile={userProfile} showEdit={false} />;
};

const mapStateToProps = (state, ownProps) => ({
  userProfile: getMemberHabitProfile(state)
});

export default connect(mapStateToProps)(Habit);



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/ProfileInformation/Habit/index.js